import React from "react";
import CurrencyCalculationForm from "./CurrencyCalculationForm";

const BottomLine = () => {
  return (
    <div className="bottom-line">
      <CurrencyCalculationForm />
    </div>
  );
};

export default BottomLine;
